import { render, staticRenderFns } from "./platformset.vue?vue&type=template&id=90db61c6&"
import script from "./platformset.vue?vue&type=script&lang=js&"
export * from "./platformset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports